
export const FULL_LOADING_SHOW = 'FULL_LOADING_SHOW';
export const FULL_LOADING_HIDE = 'FULL_LOADING_HIDE';

export function fullLoadingShow() {
    return {
        type: FULL_LOADING_SHOW
    }
}

export function fullLoadingHide() {
    return {
        type: FULL_LOADING_HIDE
    }
}



// WEBPACK FOOTER //
// ./src/common/components/loadings/actions.js